import React from 'react';

export enum MgpSlug {
  Summary = 'summary',
  Insurance = 'insurance',
  Goals = 'goals',
  Networth = 'networth',
}

export interface Tab {
  slug: string;
  component: React.FC;
  name: string;
  id: number;
}

export interface TabProps {
  id: number;
  clientId: string;
  tabList: Tab[];
}

export interface GaugeChartDto {
  probabilityOfSuccess: number;
  targetRangeLow: number;
  targetRangeHigh: number;
  lowColor: string | null;
  middleColor: string | null;
  highColor: string | null;
  targetStatus: string;
  targetColor: string;
}

export interface SummaryHeader {
  changes: string;
  current: string;
  description?: string;
  recommended: string;
}

export interface MonteCarloCalculations extends GaugeChartDto {
  badTiming: string;
  averageReturn: string;
  description: string;
}
interface Item {
  description: string;
  current: string;
  recommended: string;
  changes: string;
}

export interface TopicItem extends Item {
  details?: Item[];
}

export interface Topic {
  items: TopicItem[];
  description: string;
  current: string | null;
  recommended: string | null;
  changes: string | null;
}

export interface SummaryCategories {
  topics: Topic[];
  changes: string | null;
  current: string | null;
  description: string;
  recommended: string;
}

type NetWorthRecord = {
  name: string;
  totalValue: number;
  color: string | null;
};

type NetWorthAsset = {
  categories: NetWorthRecord[];
  name: string;
  totalValue: number;
  color: string | null;
};

export interface NetWorthChartSeries {
  title: string;
  values: {
    name: string;
    value: number;
    color: string;
  }[];
}

export interface NetWorthTableGroup {
  title: string;
  color: string;
  rows: {
    label: string;
    value: number;
  }[];
}

export interface NetWorthTableData {
  groups: NetWorthTableGroup[];
  netWorth: {
    value: number;
    color: string;
  };
}

export interface Policies {
  annualPremium: number;
  beneficiaries?: string[];
  cashValue: number;
  deathBenefit: number;
  description: string;
  insured: string;
  owner: string;
  premiumPaid: string;
}

export interface PolicyGroups {
  groupName: string;
  policies: Policies[];
}

export interface SummaryDto {
  header: SummaryHeader;
  monteCarloCalculations: MonteCarloCalculations[];
  summaryCategories: SummaryCategories[];
  asOfDate: string;
}

export interface InsuranceDto {
  policyGroups: PolicyGroups[];
  totalDeathBenefit: number;
  asOfDate: string;
}

export interface GoalsDto extends GaugeChartDto {
  asOfDate: string;
}

export interface NetWorthDto {
  investmentAssets: NetWorthAsset;
  otherAssets: NetWorthAsset;
  liabilities: NetWorthAsset;
  networth: Omit<NetWorthAsset, 'categories'>;
  asOfDate: string;
}

export interface RouteParams {
  tabSlug: string;
  tabId: string;
}

export interface Route {
  params: RouteParams;
}

export interface MgpReportItemResponse {
  id: number;
  name: string;
}

export interface MgpReportResponse {
  items: MgpReportItemResponse[];
  hasSsoAccess: boolean;
  ssoString: string | null;
  warmupInProgress: boolean;
  warmupStartedAt: string | null;
}

export interface MgpWarmupStatusResponse {
  warmupInProgress: boolean;
  warmupStartedAt: string | null;
  warmupCompletedAt: string | null;
}
